import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/presentations/presentations/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Quotes are set up in two different layouts: left-aligned and centered. Longer quotes should be left-aligned and shorter quotes should be centered.`}</p>
    <p><img parentName="p" {...{
        "src": "https://user-images.githubusercontent.com/10384315/54716005-01035180-4b12-11e9-9194-aa355e4610bf.png",
        "alt": "Screenshot 2019-03-20 13 13 28"
      }}></img></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      